// extracted by mini-css-extract-plugin
export default {"navbarText":"Navigation_navbarText__k4c8S","navbarColors":"Navigation_navbarColors__pW3Rt","className":"Navigation_className__kKdfP","sticky":"Navigation_sticky__eKK3p"};